import type * as Types from 'app/types/graphql';

import {
  CouponEdgeSelectFragmentDoc,
  CouponSelectFragmentDoc,
} from '../fragments/coupon.generated';
import { PromotionSelectFragmentDoc } from '../fragments/promotion.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type CouponsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where?: Types.InputMaybe<Types.CouponWhereInput>;
}>;

export type CouponsQueryResponse = {
  coupons?: Types.Maybe<{
    edges?: Types.Maybe<
      Array<
        Pick<Types.CouponEdge, 'cursor'> & {
          node?: Types.Maybe<
            Pick<Types.Coupon, 'id' | 'code'> & {
              promotion?: Types.Maybe<
                Pick<
                  Types.Promotion,
                  | 'id'
                  | 'name'
                  | 'type'
                  | 'priority'
                  | 'discountAmount'
                  | 'discountUnit'
                  | 'conditions'
                  | 'startDate'
                  | 'endDate'
                  | 'enableForAllPlans'
                > & { plans?: Types.Maybe<Array<Pick<Types.Plan, 'id' | 'name'>>> }
              >;
            }
          >;
        }
      >
    >;
  }>;
};

export const CouponsDocument = `
    query Coupons($first: Int, $where: CouponWhereInput) {
  coupons(first: $first, where: $where) {
    edges {
      ...CouponEdgeSelect
    }
  }
}
    ${CouponEdgeSelectFragmentDoc}
${CouponSelectFragmentDoc}
${PromotionSelectFragmentDoc}`;

export const useCouponsQuery = <TData = CouponsQueryResponse, TError = unknown>(
  variables?: CouponsQueryVariables,
  options?: UseQueryOptions<CouponsQueryResponse, TError, TData>,
) => {
  return useQuery<CouponsQueryResponse, TError, TData>(
    variables === undefined ? ['Coupons'] : ['Coupons', variables],
    appFetcher<CouponsQueryResponse, CouponsQueryVariables>(CouponsDocument, variables),
    options,
  );
};

useCouponsQuery.getKey = (variables?: CouponsQueryVariables) =>
  variables === undefined ? ['Coupons'] : ['Coupons', variables];
